import React from 'react';
import {FacebookLoginButton} from 'react-social-login-buttons';

export default function GoogleSignInButton({onPress}) {
  return <FacebookLoginButton onClick={() => onPress()} />;
}
